export const COLORS = {
  main: '#603030',
  accent: '#F0D8C0',
  text: '#eeeeee',
  white: '#eeeeee',
  gaara: '#603030',
  rock_lee: '#155859',
  tenten: '#b75a5e',
  tenten_alt: '#F0D8C0',
  temari: '#423c58',
  temari_alt: '#f0b8f8',
  shino: '#c0cfc8',
  shino_alt: '#353641',
  sasuke: '#103880',
  sasuke_alt: '#b75a5e',
  kiba: '#9c9ca6',
  kiba_alt: '#89193b',
  neji: '#F0D8C0',
  neji_alt: '#353641',
  shikamaru: '#788b78',
  shikamaru_alt: '#353641',
  leaf: '#36635b',
  wraps: '#F0D8C0',
  wall: '#a3625f',
  wall_alt: '#714545',
  chakra: '#3e7dc9',
  dirt00: '#2a251f', 
  dirt0: '#dbcdab',
  grass00: '#435035',
  grass0: '#87ac7b',
  base04: '#07111D',
  base03: '#02252e',
  // base03: '#002b36',
  base02: '#073642',
  base01: '#586e75',
  base00: '#657b83',
  // base0: '#96641D',
  base0: '#839496',
  base1: '#93a1a1',
  // base2: '#E19D3F',
  base2: '#eee8d5',
  base3: '#fdf6e3',
  yellow: '#b58900',
  orange: '#cb4b16',
  red: '#dc322f',
  magenta: '#d33682',
  violet: '#6c71c4',
  blue: '#268bd2',
  cyan: '#2aa198',
  green: '#859900',
  black: '#16161d',
  // // base1: '#07111D',
  // base1: '#0B0B0B',
  // base2: '#5A7178',
  // base3: '#B6ACA3',
  // base4: '#EDF6F1',
  cog1: '#27295f',
  cog2: '#3e7dc9',
  cog3: '#18c0f8',
  cog4: '#86C8E4',
  locust0: '#423a18',
  locust1: '#96641D',
  locust2: '#E19D3F',
  // locust2: '#F89339',
  locust3: '#E7C898',
  flesh1: '#833139',
  flesh2: '#CC7468',
  flesh3: '#DDA78F',
  gray: '#6D7886',
}

COLORS.bg_override = COLORS.dirt00

export const TILE_KEY = {
  'GROUND': {
    background: COLORS.bg_override || COLORS.grass0,
    foreground: COLORS.grass00,
    character: '.',
    sprite: '',
    passable: true,
    tags: ['PROVIDING_COVER', 'BURNABLE'],
    animation: [
      { background: COLORS.bg_override || COLORS.grass0, foreground: COLORS.grass0, character: ',', sprite: '"', passable: true, },
      { background: COLORS.bg_override || COLORS.grass0, foreground: COLORS.grass00, character: '.', sprite: '', passable: true, },
    ]
  },
  'GROUND_ALT': {
    background: COLORS.bg_override || COLORS.dirt0,
    foreground: COLORS.dirt00,
    character: '.',
    sprite: '.',
    passable: true,
    tags: ['PROVIDING_COVER', 'BURNABLE'],
    animation: [
      { background: COLORS.bg_override || COLORS.dirt0, foreground: COLORS.dirt0, character: '.', sprite: '.', passable: true, },
      { background: COLORS.bg_override || COLORS.dirt0, foreground: COLORS.dirt00, character: '.', sprite: '.', passable: true, },
    ]
  },
  'FLOOR': {
    background: COLORS.bg_override || COLORS.base02,
    foreground: COLORS.locust1,
    character: '',
    passable: true,
    tags: ['BURNABLE'],
  },
  'WALL': {
    background: COLORS.bg_override || COLORS.wall_alt,
    foreground: COLORS.wall,
    character: '#',
    sprite: '#',
    passable: false,
    tags: ['BURNABLE', 'WALL'],
  },
  'WALL_VERTICAL': {
    background: COLORS.bg_override || COLORS.base02,
    foreground: COLORS.locust2,
    character: '||',
    sprite: '',
    passable: false,
    tags: ['BURNABLE', 'WALL'],
  },
  'WALL_HORIZONTAL': {
    background: COLORS.bg_override || COLORS.base02,
    foreground: COLORS.locust2,
    character: '=',
    sprite: '',
    passable: false,
    tags: ['BURNABLE', 'WALL'],
  },
  'WALL_CORNER_NW': {
    background: COLORS.bg_override || COLORS.base02,
    foreground: COLORS.locust2,
    character: '#',
    sprite: '',
    passable: false,
    tags: ['BURNABLE', 'WALL'],
  },
  'WALL_CORNER_NE': {
    background: COLORS.bg_override || COLORS.base02,
    foreground: COLORS.locust2,
    character: '#',
    sprite: '',
    passable: false,
    tags: ['BURNABLE', 'WALL'],
  },
  'WALL_CORNER_SW': {
    background: COLORS.bg_override || COLORS.base02,
    foreground: COLORS.locust2,
    character: '#',
    sprite: '',
    passable: false,
    tags: ['BURNABLE', 'WALL'],
  },
  'WALL_CORNER_SE': {
    background: COLORS.bg_override || COLORS.base02,
    foreground: COLORS.locust2,
    character: '#',
    sprite: '',
    passable: false,
    tags: ['BURNABLE', 'WALL'],
  },
  'ROAD_EDGE': {
    background: COLORS.bg_override || COLORS.base03,
    foreground: COLORS.base02,
    character: '',
    sprite: '',
    passable: true,
    tags: ['ROAD', 'PROVIDING_COVER'],
  },
  'ROAD': {
    background: COLORS.bg_override || COLORS.base03,
    foreground: COLORS.base02,
    character: '=',
    sprite: '',
    passable: true,
    tags: ['ROAD', 'PROVIDING_COVER'],
  },
  'DOOR': {
    background: COLORS.bg_override || COLORS.base02,
    foreground: COLORS.base1,
    character: '+',
    sprite: '',
    passable: true,
    tags: ['BURNABLE'],
  },
  'SAFE': {
    background: COLORS.bg_override || COLORS.base04,
    foreground: COLORS.base02,
    character: '.',
    sprite: '',
    passable: true,
  },
  'LOCKED_EXIT': {
    background: COLORS.bg_override || COLORS.base04,
    foreground: COLORS.base02,
    character: '.',
    sprite: '',
    passable: true,
  },
  'EXIT': {
    background: COLORS.bg_override || COLORS.base04,
    foreground: COLORS.green,
    character: '>',
    sprite: '',
    passable: true,
  },
  'BURNT': {
    background: COLORS.bg_override || COLORS.base03,
    foreground: COLORS.red,
    character: 'X',
    sprite: '',
    passable: true,
    tags: ['BURNABLE'],
    animation: [
      { background: COLORS.bg_override || COLORS.base03, foreground: COLORS.yellow, character: 'X', sprite: '', passable: true, },
      { background: COLORS.bg_override || COLORS.base03, foreground: COLORS.yellow, character: 'x', sprite: '', passable: true, },
      { background: COLORS.bg_override || COLORS.base03, foreground: COLORS.red, character: 'X', sprite: '', passable: true, },
      { background: COLORS.bg_override || COLORS.base03, foreground: COLORS.orange, character: 'x', sprite: '', passable: true, },
      { background: COLORS.bg_override || COLORS.base03, foreground: COLORS.orange, character: 'X', sprite: '', passable: true, },
      { background: COLORS.bg_override || COLORS.base03, foreground: COLORS.red, character: 'x', sprite: '', passable: true, },
      { background: COLORS.bg_override || COLORS.base03, foreground: COLORS.red, character: 'X', sprite: '', passable: true, },
    ]
  },
  'WATER': {
    animation: [
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '=', passable: false, },
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '%', passable: false, },
    ],
    background: COLORS.bg_override || COLORS.cog2,
    foreground: COLORS.cog1,
    character: '~',
    passable: false,
    forceAnimate: true,
  },
}
// export const TILE_KEY = {
//   'GROUND': {
//     background: COLORS.grass0,
//     foreground: COLORS.grass00,
//     character: '.',
//     sprite: '',
//     passable: true,
//     tags: ['PROVIDING_COVER'],
//     animation: [
//       { background: COLORS.grass0, foreground: COLORS.grass0, character: ',', sprite: '"', passable: true, },
//       { background: COLORS.grass0, foreground: COLORS.grass00, character: '.', sprite: '', passable: true, },
//     ]
//   },
//   'GROUND_ALT': {
//     background: COLORS.dirt0,
//     foreground: COLORS.dirt00,
//     character: '.',
//     sprite: '.',
//     passable: true,
//     tags: ['PROVIDING_COVER'],
//     animation: [
//       { background: COLORS.dirt0, foreground: COLORS.dirt0, character: '.', sprite: '.', passable: true, },
//       { background: COLORS.dirt0, foreground: COLORS.dirt00, character: '.', sprite: '.', passable: true, },
//     ]
//   },
//   'FLOOR': {
//     background: COLORS.base02,
//     foreground: COLORS.locust1,
//     character: '',
//     passable: true,
//     tags: ['BURNABLE'],
//   },
//   'WALL': {
//     background: COLORS.wall_alt,
//     foreground: COLORS.wall,
//     character: '#',
//     sprite: '#',
//     passable: false,
//     tags: ['BURNABLE', 'WALL'],
//   },
//   'WALL_VERTICAL': {
//     background: COLORS.base02,
//     foreground: COLORS.locust2,
//     character: '||',
//     sprite: '',
//     passable: false,
//     tags: ['BURNABLE', 'WALL'],
//   },
//   'WALL_HORIZONTAL': {
//     background: COLORS.base02,
//     foreground: COLORS.locust2,
//     character: '=',
//     sprite: '',
//     passable: false,
//     tags: ['BURNABLE', 'WALL'],
//   },
//   'WALL_CORNER_NW': {
//     background: COLORS.base02,
//     foreground: COLORS.locust2,
//     character: '#',
//     sprite: '',
//     passable: false,
//     tags: ['BURNABLE', 'WALL'],
//   },
//   'WALL_CORNER_NE': {
//     background: COLORS.base02,
//     foreground: COLORS.locust2,
//     character: '#',
//     sprite: '',
//     passable: false,
//     tags: ['BURNABLE', 'WALL'],
//   },
//   'WALL_CORNER_SW': {
//     background: COLORS.base02,
//     foreground: COLORS.locust2,
//     character: '#',
//     sprite: '',
//     passable: false,
//     tags: ['BURNABLE', 'WALL'],
//   },
//   'WALL_CORNER_SE': {
//     background: COLORS.base02,
//     foreground: COLORS.locust2,
//     character: '#',
//     sprite: '',
//     passable: false,
//     tags: ['BURNABLE', 'WALL'],
//   },
//   'ROAD_EDGE': {
//     background: COLORS.base03,
//     foreground: COLORS.base02,
//     character: '',
//     sprite: '',
//     passable: true,
//     tags: ['ROAD', 'PROVIDING_COVER'],
//   },
//   'ROAD': {
//     background: COLORS.base03,
//     foreground: COLORS.base02,
//     character: '=',
//     sprite: '',
//     passable: true,
//     tags: ['ROAD', 'PROVIDING_COVER'],
//   },
//   'DOOR': {
//     background: COLORS.base02,
//     foreground: COLORS.base1,
//     character: '+',
//     sprite: '',
//     passable: true,
//     tags: ['BURNABLE'],
//   },
//   'SAFE': {
//     background: COLORS.base04,
//     foreground: COLORS.base02,
//     character: '.',
//     sprite: '',
//     passable: true,
//   },
//   'LOCKED_EXIT': {
//     background: COLORS.base04,
//     foreground: COLORS.base02,
//     character: '.',
//     sprite: '',
//     passable: true,
//   },
//   'EXIT': {
//     background: COLORS.base04,
//     foreground: COLORS.green,
//     character: '>',
//     sprite: '',
//     passable: true,
//   },
//   'BURNT': {
//     background: COLORS.base03,
//     foreground: COLORS.red,
//     character: 'X',
//     sprite: '',
//     passable: true,
//     tags: ['BURNABLE'],
//     animation: [
//       { background: COLORS.base03, foreground: COLORS.yellow, character: 'X', sprite: '', passable: true, },
//       { background: COLORS.base03, foreground: COLORS.yellow, character: 'x', sprite: '', passable: true, },
//       { background: COLORS.base03, foreground: COLORS.red, character: 'X', sprite: '', passable: true, },
//       { background: COLORS.base03, foreground: COLORS.orange, character: 'x', sprite: '', passable: true, },
//       { background: COLORS.base03, foreground: COLORS.orange, character: 'X', sprite: '', passable: true, },
//       { background: COLORS.base03, foreground: COLORS.red, character: 'x', sprite: '', passable: true, },
//       { background: COLORS.base03, foreground: COLORS.red, character: 'X', sprite: '', passable: true, },
//     ]
//   },
//   'WATER': {
//     animation: [
//       { background: COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
//       { background: COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
//       { background: COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
//       { background: COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
//       { background: COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
//       { background: COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
//       { background: COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
//       { background: COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
//       { background: COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
//       { background: COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
//       { background: COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
//       { background: COLORS.cog1, foreground: COLORS.cog2, character: '=', passable: false, },
//       { background: COLORS.cog1, foreground: COLORS.cog2, character: '%', passable: false, },
//     ],
//     background: COLORS.cog2,
//     foreground: COLORS.cog1,
//     character: '~',
//     passable: false,
//     forceAnimate: true,
//   },
// }

export const STAT_RENDERERS = {
  'amount': {
    background: COLORS.base04,
    foreground: COLORS.locust2,
    character: '',
  },
  'attackRange': {
    background: COLORS.green,
    foreground: COLORS.base3,
    character: '==>',
  },
  'magazine': {
    background: COLORS.gray,
    foreground: COLORS.base3,
    character: '!!',
  },
  'baseRangedAccuracy': {
    background: COLORS.violet,
    foreground: COLORS.base3,
    character: '*',
  },
  'baseRangedDamage': {
    background: COLORS.red,
    foreground: COLORS.base3,
    character: 'x',
    sprite: '',
  },
  'meleeDamage': {
    background: COLORS.red,
    foreground: COLORS.base3,
    character: 'x',
    sprite: '',
  },
} 

// GiArcheryTarget / GiBullseye / GiCrosshair -- accuracy
// GiBullets -- ammo
// GiBackwardTime -- ammo / reload
//  GiBarbedArrow - -range
// GiBurningDot -- damage
// GiCog

/*
SCROLL-O-Sprites







 
*/
